export const PRODUCT_TITLE =
  "PriceBlocs - Sell anything, anywhere, with payment links.";
export const PRODUCT_TAG_HEADER =
  "Sell anything, anywhere, with payment links.";
export const PRODUCT_TAG_SUBHEADER =
  "Monetize your products, in any channel, without coding. Accept payments instantly with just the click of a link.";
